import React, { Component } from "react";
import IProperties from './IProperties';

export default class IComponent extends IProperties(Component) {

}



// WEBPACK FOOTER //
// ./src/interfaces/IComponent.js